
const sfProRegular = new URL("./assets/fonts/SFPro/SFPro-Regular.woff", import.meta.url);
const sfProLight = new URL("./assets/fonts/SFPro/SFProText-Light.woff", import.meta.url);
const sfProRegular2 = new URL("./assets/fonts/SFPro/SFPro-Regular.woff2", import.meta.url);
const sfProLight2 = new URL("./assets/fonts/SFPro/SFProText-Light.woff2", import.meta.url);

const sfProText = new URL("./assets/fonts/SFPro/SFProText-Regular.woff", import.meta.url);
const sfProText2 = new URL("./assets/fonts/SFPro/SFProText-Regular.woff2", import.meta.url);

const PreloadFonts = () => (
  <>
    <link rel="preload" href={sfProRegular} as="font" type="font/woff" crossOrigin="anonymous" />
    <link rel="preload" href={sfProLight} as="font" type="font/woff" crossOrigin="anonymous" />
    <link rel="preload" href={sfProRegular2} as="font" type="font/woff2" crossOrigin="anonymous" />
    <link rel="preload" href={sfProLight2} as="font" type="font/woff2" crossOrigin="anonymous" />
    <link rel="preload" href={sfProText} as="font" type="font/woff" crossOrigin="anonymous" />
    <link rel="preload" href={sfProText2} as="font" type="font/woff2" crossOrigin="anonymous" />
  </>
);

export default PreloadFonts;